import {
  InherentRiskCategoryEnum,
  InherentRiskItem,
  InherentRiskSource,
} from '@/gen/inventory/v1/company_service_pb'

export const isDisplayedItem = (item: InherentRiskItem, categoryEnum: InherentRiskCategoryEnum) =>
  categoryEnum !== InherentRiskCategoryEnum.DATA_SUBPROCESSOR ||
  item.displayName !== 'No' ||
  item.source === InherentRiskSource.INTAKE
